import React, { useEffect } from 'react';
// import '../../../src/style.css';
// import logo from '../../Assets/logo.png';

const ChatbotButton = () => {
  useEffect(() => {
    // Inject the Botpress Webchat scripts when component mounts
    const script1 = document.createElement('script');
    script1.src = 'https://cdn.botpress.cloud/webchat/v1/inject.js';
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement('script');
    script2.src = 'https://mediafiles.botpress.cloud/5386d3c0-336b-491f-8b7c-240df22f880f/webchat/config.js';
    script2.defer = true;
    document.body.appendChild(script2);

    return () => {
      // Cleanup scripts when the component is unmounted
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);

  return (
    <div className="chatbot-button" onClick={() => window.botpressWebChat?.toggle()}>

    </div>
  );
};

export default ChatbotButton;


